export default __webpack_public_path__ + "img_220720_Indigenous_at_logo_color.svg";